export default __webpack_public_path__ + "static/media/city411_screenshot.8350b500.jpg";